// extracted by mini-css-extract-plugin
module.exports = {"Pill":"Pill_Pill__1m29J"};